import script from "./contextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./contextMenu.vue?vue&type=script&setup=true&lang=js"

import "./contextMenu.vue?vue&type=style&index=0&id=0fc83c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc83c50"]])

export default __exports__